<template>
  <div class="treeWrapper" ref="wrapper">
    <el-input
      v-if="searchInput"
      placeholder="搜索分组"
      size="small"
      v-model="filterText"
      style="margin: 5px 0; width: 100%"
    ></el-input>
    <el-tree
      ref="tree"
      :data="treeData"
      label="title"
      node-key="id"
      :default-checked-keys="groupChosenIds"
      default-expand-all
      :props="propsSet"
      :show-checkbox="showCheckbox"
      :check-on-click-node="checkOnClickNode"
      :expand-on-click-node="expandOnClickNode"
      :allow-drag="allowDrag"
      :allow-drop="allowDrop"
      highlight-current
      :check-strictly="checkStrictly"
      :filter-node-method="filterNode"
      @node-contextmenu="showContextmenu"
      @node-drag-end="dragComplete"
      @node-click="treeSelect"
      draggable
    >
      <!-- <div slot-scope="{ node, data }">
        <div class="treeBar">
          <i
            :class="data.expand ? 'el-icon-folder-opened' : 'el-icon-folder'"
          ></i>
          {{ data }}222323
        </div>
      </div> -->
    </el-tree>
    <div
      class="contextBox"
      v-if="contextDataIfShow"
      :style="{ top: contextData.y + 'px', left: contextData.x + 'px' }"
    >
      <p
        class="contextSelect"
        @click.prevent="contextmenuAct('create')"
        v-show="contextData.id > 0"
      >
        新建子部门
      </p>
      <p class="contextSelect" @click.prevent="contextmenuAct('create', true)">
        新建同级部门
      </p>
      <p
        class="contextSelect"
        @click.prevent="contextmenuAct('rename')"
        v-show="contextData.id > 1"
      >
        编辑
      </p>
      <p
        class="contextSelect"
        @click.prevent="contextmenuAct('delete')"
        v-show="contextData.id > 1"
      >
        删除
      </p>
    </div>

    <el-dialog
      :title="inputModel.title"
      :visible.sync="inputModel.ifShow"
      width="60%"
      :append-to-body="true"
    >
      <Input
        v-model="inputModel.value"
        size="large"
        placeholder="请输入组织架构名"
      />

      <!-- </Modal> -->
      <div slot="footer">
        <el-button type="primary" @click="inputModelConfirm">{{
          inputModel.okText
        }}</el-button>
        <el-button type="primary" plain @click="inputModel.ifShow = false">{{
          inputModel.cancelText
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    treeData: Array,
    checkStrictly: { type: Boolean, default: false },
    showCheckbox: { type: Boolean, default: false },
    groupChosenIds: Array,
    propsSet: {
      type: Object,
      default: () => {
        return { children: "children", label: "groupName" };
      },
    },
    searchInput: { type: Boolean, default: false },
    checkOnClickNode: { type: Boolean, default: false },
    expandOnClickNode: { type: Boolean, default: true },
  },
  data() {
    return {
      contextData: { x: "", y: "", ifShow: false },
      contextDataIfShow: false,
      inputModel: {
        title: "部门编辑",
        ifShow: false,
        styles: {},
        okText: "确认",
        cancelText: "取消",
        loading: false,
        value: "",
      },
      filterText: "",
      filterTimeout: "",
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    allowDrag(node) {
      return !(node.data.id == 0 || node.data.id == 1);
    },
    allowDrop(drag, drop, type) {
      return !(drop.data.id == 0);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    contextmenuAct(type, ifSameParent = false) {
      this.contextData.ifSameParent = ifSameParent;
      switch (type) {
        case "create":
          this.$emit("eventUp", {
            type: "append",
            parentId: this.contextData.ifSameParent
              ? this.contextData.parentId
              : this.contextData.id,
          });
          // Object.assign(this.inputModel, {
          //   title: "创建组织架构",
          //   ifShow: true,
          //   okText: "创建",
          //   value: "",
          //   type: "append",
          // });

          break;
        case "rename":
          this.$emit("eventUp", {
            type: "rename",
            item: this.contextData,
          });
          // Object.assign(this.inputModel, {
          //   title: "编辑",
          //   ifShow: true,
          //   okText: "确认",
          //   value: this.contextData.groupName,
          //   type: "rename",
          // });
          break;
        case "delete":
          this.$emit(
            "eventUp",
            {
              type: "delete",
              item: this.contextData,
              callback: () => {
                this.$emit("dataUpdate", this.treeData);
              },
            },
            this.treeData
          );

          break;
        case "toTop":
          this.$emit(
            "eventUp",
            {
              type: "move",
              item: this.contextData,
              parentId: 0,
              title: this.contextData.title,
            },
            this.treeData
          );
          break;
        default:
          break;
      }
    },
    setCheckedKeys(keys) {
      this.$refs.tree.setCheckedKeys(keys);
    },
    getChosenKeys() {
      // console.log("chosenkey", this.$refs.tree.getCheckedKeys(true));
      this.$emit(
        "eventUp",
        {
          type: "chosenKeysConfirm",
          chosenKeys: this.$refs.tree.getCheckedKeys(),
        },
        this.treeData
      );
    },
    showContextmenu(e, data, node) {
      this.contextData = {
        x: e.x - this.$refs.wrapper.getBoundingClientRect().x,
        y: e.y - this.$refs.wrapper.getBoundingClientRect().y,
        ifShow: true,
      };
      // console.log(data);
      this.contextDataIfShow = true;
      Object.assign(this.contextData, data);
      document.body.addEventListener("click", this.hideContextMenu);
    },
    hideContextMenu() {
      this.contextDataIfShow = false;
      document.body.removeEventListener("click", this.hideContextMenu);
    },
    dragComplete(dragNode, nextNode, type, dragEvent) {
      if (type == "none") {
        return;
      }
      console.log(dragNode.data.id, nextNode.data.id);

      this.$emit(
        "eventUp",
        {
          type: "move",
          item: dragNode.data.id,
          parentId: type == "inner" ? nextNode.data.id : nextNode.data.parentId,
          title: dragNode.data.title,
        },
        this.treeData
      );
    },
    inputModelConfirm() {
      console.log(this.inputModel.type);
      switch (this.inputModel.type) {
        case "rename":
          this.$emit(
            "eventUp",
            {
              type: "rename",
              item: this.contextData,
              value: this.inputModel.value,
              callback: () => {
                this.inputModel.ifShow = false;
              },
            },
            this.treeData
          );
          break;
        case "append":
          this.$emit(
            "eventUp",
            {
              type: "append",
              item: this.contextData,
              parentId: this.contextData.ifSameParent
                ? this.contextData.parentId
                : this.contextData.id,
              title: this.inputModel.value,
            },
            this.treeData
          );
          break;
        default:
          break;
      }
      this.inputModel.ifShow = false;
    },
    getCheckedNodes(leafOnly = false, includeHalfChecked = false) {
      return this.$refs.tree.getCheckedNodes(leafOnly, includeHalfChecked);
    },
    setChosenNode(nodes) {
      this.$refs.tree.setCheckedNodes(nodes);
    },
    treeSelect(data, node) {
      this.$emit("eventUp", { type: "select", item: data }, this.treeData);
    },
  },
  created() {},
  mounted() {
    console.log(this.treeData);
  },
};
</script>
<style lang="less" scoped>
.treeWrapper {
  // padding: 10px 0 !important;
  position: relative;
  background: #fff;
  .treeBar {
    font-size: 14px;
  }
  .contextBox {
    position: absolute;
    border: 1px solid #ccc;
    background: #fff;
    z-index: 11;
    padding: 10px 0;
    box-sizing: border-box;
    box-shadow: 0px 3px 10px 0px rgba(54, 170, 253, 0.3);
    .contextSelect {
      min-width: 100px;
      padding: 0 10px;
      font-size: 1.3em;
      text-decoration: none;
      width: auto;
      color: #000;
      white-space: nowrap;
      line-height: 2.4em;
      text-shadow: 1px 1px 0 #fff;
      border-radius: 1px;
      cursor: pointer;
    }
    .contextSelect:hover {
      background: #beebff;
      color: #333;
      // color: #fff;
    }
  }
  /deep/ .ivu-icon-ios-arrow-forward:before {
    content: "\f100";
  }
  /* treeExpand */
  /deep/ .ivu-tree-arrow-open .ivu-icon-ios-arrow-forward:before {
    content: "\f290";
  }
  /deep/ .ivu-tree-arrow-open .ivu-icon {
    -webkit-transform: rotate(0deg) scale(1);
    -ms-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  /deep/ .ivu-tree-arrow:hover .ivu-icon {
    color: #618afd !important;
    border-color: #618afd;
  }
  /deep/ .ivu-tree-arrow i {
    font-size: 16px;
  }
  /deep/ .ivu-tree-title {
    width: 100%;
  }
  /deep/ .ivu-tree-title {
    width: calc(100% - 12px);
  }
}
</style>